export interface MailItem {
    id: string;
    sender: string;
    subject: string;
    preview: string;
    time: string;
    read: boolean;
    type: 'notification' | 'bill' | 'security' | 'promotion';
}

const senders = ['Binance', 'Coinbase', 'Metamask', 'System Security', 'Uniswap Protocol', 'OpenSea'];
const subjects = [
    'Login Attempt Detected',
    'Your deposit of 500 USDT is successful',
    'Security Alert: New IP Address',
    'Weekly Market Report: BTC hits $100k',
    'Airdrop Notification: Claim your tokens',
    'Your order #12345678 has been filled'
];
const types: MailItem['type'][] = ['notification', 'bill', 'security', 'promotion'];

export const generateMailData = (count: number = 2000): MailItem[] => {
    return Array.from({ length: count }).map((_, index) => {
        const type = types[Math.floor(Math.random() * types.length)];
        return {
            id: `mail-${index}`,
            sender: senders[Math.floor(Math.random() * senders.length)],
            subject: subjects[Math.floor(Math.random() * subjects.length)],
            preview: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            time: `${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
            read: Math.random() > 0.3,
            type,
        };
    });
};
